import { render } from "./EditNews.vue?vue&type=template&id=83f7fb46"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"
script.render = render

export default script